<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
    >
    <template slot="left" >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.data')}}</h1>
      </v-toolbar-title>
    </template>
  </Toolbar>
    <ProductDataForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProductDataForm from '../../components/productdata/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ProductData';
const routeAfterDel = 'ProductShow';
const routeAfterDelId = 'product';
const routeAfterDelIdObject  = 'product';
export default {
  name: 'ProductDataUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  routeAfterDelIdObject,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProductDataForm
  },

  computed: {
    ...mapFields('productdata', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('productdata', ['find'])

  },

  methods: {
    ...mapActions('productdata', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })

  }
};
</script>
